import type { ProformOrder } from '@eliadmin/core/src/api/proform/proform-types';
import { Badge } from '@eliadmin/core/src/components/ui/badge';

export type ProfileOrderStatusProps = {
  order: ProformOrder;
};

export function getOrderStatus(order: ProformOrder) {
  if (order.vyrzeno_kl === '1') {
    return { status: 'Vyřízeno', colorClass: 'bg-green-500 text-white' };
  }

  if (order.dodano === '2') {
    return { status: 'Částečne dodáno', colorClass: 'bg-yellow-500 text-black' };
  }

  if (order.dodano === '1') {
    return { status: 'Dodáno', colorClass: 'bg-blue-500 text-white' };
  }

  if (order.odsouhlaseno === '1') {
    return { status: 'Odsouhlaseno', colorClass: 'bg-purple-500 text-white' };
  }

  return { status: 'Přebíha', colorClass: 'bg-gray-500 text-white' };
}

export function ProfileOrderStatus(props: ProfileOrderStatusProps) {
  const status = getOrderStatus(props.order);

  return (
    <Badge className={`whitespace-nowrap text-center text-sm ${status.colorClass}`}>
      {status.status}
    </Badge>
  );
}
